module.exports = __webpack_public_path__ + "images/ic-feature-1024-b0b33bae519c94abdce5efe52b834e30.png";